import React from 'react';
import classNames from 'classnames';
import styles from './ContainerHead.module.scss';

export interface ContainerHeadProps {
  children: React.ReactNode;
}

const ContainerHead: React.FC<ContainerHeadProps> = ({ children }) => {
  return <div className={classNames(styles.root)}>{children}</div>;
};

export default ContainerHead;
